/**
 * The search box at the top of a SearchableSelect's dropdown (focused when
 * it opens), with room for an extra header control (e.g. a tag filter).
 */

import type { ReactNode } from 'react';
import { Search } from 'lucide-react';

interface SearchableSelectSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  headerSlot?: ReactNode;
}

export function SearchableSelectSearch({ value, onChange, placeholder, headerSlot }: SearchableSelectSearchProps) {
  return (
    <div className="border-b border-border p-2">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex min-w-0 flex-1 items-center gap-2 rounded-md border border-input bg-background px-2 py-1.5">
          <Search className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
          <input
            type="search"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="min-w-0 flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground"
            autoFocus
            autoComplete="off"
          />
        </div>
        {headerSlot}
      </div>
    </div>
  );
}
